import { useState } from "react";
import {
  Modal, Box, Grid, Typography, IconButton,
  TextField, Button, MenuItem, Alert,Collapse, Tooltip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
const posiciones = ["Arquero", "Defensor", "Delantero"];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85%",
  maxWidth: 400,
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",      // <--- Permite limitar la altura
  overflowY: "auto",      // <--- Habilita el scroll vertical
};


const preferencias = [
  { value: "me_sumo_disponible", label: "Me sumo si estoy disponible" },
  { value: "no_pago_cancha", label: "Me sumo pero no pago la cancha" },
  { value: "cobro_por_sumarme", label: "Cobro por sumarme" },
  { value: "coordino_con_organizador", label: "Coordino con el organizador" },
];
const ModalRegistro = ({ open, onClose, onRegister, formData, setFormData }) => {
  const [error, setError] = useState("");
    const [verMas, setVerMas] = useState(false);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    onRegister();
  };

  return (
   <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h6" component="h2">
            Crear cuenta
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Grid>

        <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
          Unite y empezá a armar tus partidos.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
               <TextField
            fullWidth label="Usuario" name="usuario"
            variant="outlined" margin="dense"
            value={formData.usuario} onChange={handleChange}
          />
                <TextField
            fullWidth label="Contraseña" name="password"
            type="password" variant="outlined" margin="dense"
            value={formData.password} onChange={handleChange}
          />
<TextField
  fullWidth
  label="Fecha de nacimiento"
  name="fecha_nacimiento"
  type="date"
  InputLabelProps={{
    shrink: true,
  }}
  variant="outlined"
  margin="dense"
  value={formData.fecha_nacimiento || ""}
  onChange={(e) => {
    setFormData({ ...formData, fecha_nacimiento: e.target.value }); // Mantiene formato yyyy-mm-dd
  }}
/>


          <TextField
            fullWidth label="Nombre completo" name="nombre"
            variant="outlined" margin="dense"
            value={formData.nombre} onChange={handleChange}
          />
              <TextField
            fullWidth label="Apodo" name="apodo"
            variant="outlined" margin="dense"
            value={formData.apodo} onChange={handleChange}
          />
     
          <TextField
            fullWidth label="Email" name="email"
            variant="outlined" margin="dense"
            value={formData.email} onChange={handleChange}
          />
          <TextField
            fullWidth label="Teléfono" name="tel"
            variant="outlined" margin="dense"
            value={formData.tel} onChange={handleChange}
          />
    
      
          <TextField
            fullWidth label="Barrio" name="barrio"
            variant="outlined" margin="dense"
            value={formData.barrio} onChange={handleChange}
          />
          <TextField
            select fullWidth label="Posición" name="posicion"
            variant="outlined" margin="dense"
            value={formData.posicion} onChange={handleChange}
          >
            {posiciones.map((pos) => (
              <MenuItem key={pos} value={pos}>
                {pos}
              </MenuItem>
            ))}
          </TextField>
<Box sx={{ mt: 2 }}>
  <Box display="flex" alignItems="center" gap={1}>
    <Typography variant="subtitle2">Preferencia de convocatoria</Typography>
    <Tooltip title="Ver más detalles">
      <IconButton size="small" onClick={() => setVerMas(!verMas)}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </Box>

  <Collapse in={verMas}>
    <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
      Esta opción es para las personas que reciban la invitación a sumarse a un partido.
      Podés poner como referencia que no pagás por la cancha o si sos jugador pago.
    </Typography>
  </Collapse>

  <Grid container spacing={1} sx={{ mt: 1 }}>
    <Grid item xs={12}>
      <label>
        <input
          type="checkbox"
          checked={formData.me_sumo_disponible === "Si"}
          onChange={(e) =>
            setFormData({
              ...formData,
              me_sumo_disponible: e.target.checked ? "Si" : "No",
            })
          }
        />
        {" "}Me sumo si estoy disponible
      </label>
    </Grid>
    <Grid item xs={12}>
      <label>
        <input
          type="checkbox"
          checked={formData.no_pago_cancha === "Si"}
          onChange={(e) =>
            setFormData({
              ...formData,
              no_pago_cancha: e.target.checked ? "Si" : "No",
            })
          }
        />
        {" "}No pagar cancha
      </label>
    </Grid>
    <Grid item xs={12}>
      <label>
        <input
          type="checkbox"
          checked={formData.es_pago === "Si"}
          onChange={(e) =>
            setFormData({
              ...formData,
              es_pago: e.target.checked ? "Si" : "No",
            })
          }
        />
        {" "}Soy jugador pago
      </label>
    </Grid>
  </Grid>
</Box>
          <Button
            type="submit" fullWidth variant="contained"
            sx={{ mt: 2, bgcolor: "#2E7D32", color: "#fff", fontWeight: "bold" }}
          >
            Registrarse
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default ModalRegistro;
